<template>
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper pb-0">
            <h3 class="element-header">
            Dashboard
          </h3>
      </div>
      <div class="row">
        <div class="col">
          <!--
          <div class="element-wrapper">
            <div class="element-content">
              <div class="row">
                <div class="col-sm-4 col-xxxl-4">
                  <a class="element-box el-tablo" href="#">
                    <div class="label">
                      Atendimentos (Julho/2018)
                    </div>
                    <div class="value">
                      57
                    </div>

                  </a>
                </div>
                <div class="col-sm-4 col-xxxl-4">
                  <a class="element-box el-tablo" href="#">
                    <div class="label">
                      Faturamento Bruto
                    </div>
                    <div class="value">
                      R$457,00
                    </div>
                
                  </a>
                </div>
                <div class="col-sm-4 col-xxxl-4">
                  <a class="element-box el-tablo" href="#">
                    <div class="label">
                      Novos Clientes
                    </div>
                    <div class="value">
                      125
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>-->
          <div class="row pt-4" v-if="utilizaAgendamento">
            <div class="col-sm-12">
              <!--START - Recent Ticket Comments-->
              <div class="element-wrapper">
                <h6 class="element-header">
                  Últimas Solicitações de Agendamento
                </h6>
                <div class="element-box-tp">
                  <div class="table-responsive">
                    <table class="table table-padded">
                      <thead>
                        <tr>
                          <th>
                            Paciente
                          </th>
                          <th>
                            Serviço
                          </th>
                          <th class="text-center">
                            Data / Hora
                          </th>
                          <th>
                            Tipo Pgto.
                          </th>
                          <th>
                            Agendamento
                          </th>
                          <th>
                            
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pedido in listAgendamento" :key="pedido._id">
                          <td>
                            <div class="user-with-avatar">
                              <span>{{pedido.cliente.name}}</span>
                            </div>
                          </td>
                          <td>
                            <div class="smaller lighter">
                              {{exibeServico(pedido)}}<br/>
                              <small>{{pedido.profissional.nome}}</small><br />
                              <small>{{pedido.profissional.tipoRegistro}}: {{pedido.profissional.numeroRegistro}}</small>
                            </div>
                          </td>
                          <td>
                            <span>{{pedido.agendamento.dataEscolhida}}</span><span class="smaller lighter">- {{pedido.agendamento.horarioEscolhido.horario}}</span>
                          </td>
                          <td class="text-center">
                            <a :class="{'badge-success-inverted': pedido.tipoPagamento === 'SinSaude', 'badge-info-inverted': pedido.tipoPagamento === 'Drachei'}" class="badge" href="">{{pedido.tipoPagamento}}</a>
                          </td>
                          <td class="nowrap">
                            <span class="status-pill smaller"
                              :class="{'green': pedido.statusAgendamentoDrAchei === 'CONFIRMADA', 
                                        'yellow' : pedido.statusAgendamentoDrAchei === 'AGUARDANDO_CONFIRMACAO',
                                        'red': pedido.statusAgendamentoDrAchei === 'CANCELADA'}"></span><span>{{pedido.statusAgendamentoDrAchei}}</span>
                          </td>
                          <td class="row-actions">
                            <a href="#"><i class="os-icon os-icon-grid-10"></i></a>
                            <a href="#"><i class="os-icon os-icon-ui-44"></i></a>
                            <a class="danger" href="#"><i class="os-icon os-icon-ui-15"></i></a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!--END - Recent Ticket Comments-->
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 col-xxxl-6">
              <div class="element-wrapper">
                <h6 class="element-header">
                  Últimas Solicitações
                </h6>
                <div class="element-box">
                  <div class="table-responsive">
                    <table class="table table-lightborder">
                      <thead>
                        <tr>
                          <th>
                            Paciente
                          </th>
                          <th>
                            Serviço
                          </th>
                          <th class="text-center">
                            Status
                          </th>
                          <th class="text-right">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="pedido in listUltimasSolicitacoes" :key="pedido._id">
                          <td class="nowrap">
                            {{pedido.cliente.name}}
                          </td>
                          <td>
                            <span>{{exibeServico(pedido)}}</span>
                          </td>
                          <td class="text-center">
                            <div :class="{'green': pedido.statusPagamento === 'CONCLUIDO', 'yellow': pedido.statusPagamento === 'AGUARDANDO_PAGAMENTO'}" class="status-pill" data-toggle="tooltip" data-original-title="" title=""></div>
                          </td>
                          <td class="text-right">
                            {{pedido.valorTotal | money}} 
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="col-sm-3" v-if="user.role ==='AdminRede'">
          <div class="element-wrapper">
            <h6 class="element-header">
              Profissionais | {{ rede.nomeRede }}
            </h6>
            <div class="element-box-tp">
              <div class="input-search-w">
                <input class="form-control rounded bright" placeholder="Pesquisar membros do time..." type="search">
              </div>
              <div class="users-list-w">
                <div class="user-w with-status status-green" 
                  v-for="profissional in listProfissional" :key="profissional._id">
                  <div class="user-avatar-w">
                    <div class="user-avatar">
                      <img alt="" src="@/img/avatar1.jpg">
                    </div>
                  </div>
                  <div class="user-name">
                    <h6 class="user-title">
                      {{profissional.nome}}
                    </h6>
                    <div class="user-role">
                      Médico
                    </div>
                  </div>
                  <a class="user-action" href="users_profile_small.html">
                    <div class="os-icon os-icon-email-forward"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  </div>
  
</template>
<script>
import * as http from 'axios'

export default {
  computed: {
    rede () {
      return this.$store.getters.rede || {}
    },
    logado () {
      return this.$store.getters.user
    },
    naoLogado () {
      return !this.$store.getters.user
    },
    user () {
      return this.$store.getters.user
    },
    utilizaAgendamento () {
      return this.$store.getters.rede && this.$store.getters.rede.agendamento
    }
  },
  data () {
    return {
      listProfissional: [],
      listAgendamento: [],
      listUltimasSolicitacoes: []
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
        .then(() => this.$router.push({name: 'Login'}))
    },
    exibeServico (pedido) {
      if (pedido.consulta) {
        return `Consulta ${pedido.consulta.especialidade.nome}`
      }
      return ''
    },
    async loadAgendamentos () {
      if (this.rede.agendamento) {
        const response = await http.get(`/pedidos/agendamento?unidade=${this.rede._id}`)
        this.listAgendamento = response.data
      }
    }
  },
  async created () {
    if (this.rede._id) {
      const response = await http.get(`/pedidos?limit=5&sort=-createdAt&unidade=${this.rede._id}&populate=cliente&statusPagamento__ne=INICIADO`)
      this.listUltimasSolicitacoes = response.data.filter(pedido => !pedido.agendamento)

      this.loadAgendamentos()
    }
  },
  mounted () {
    this.$store.dispatch('getCorpoClinico')
      .then((listProfissional) => {
        this.listProfissional = listProfissional
      })
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard/HomeAdmin.vue